// This functionality recreates the cart if a product that was added with the "add-product-by-code" feature is removed from it.
// It is necessary to recreate the cart to get rid of the discount that adds this product on the checkout page.
const productsInCartText = document.getElementById('productsInCart')? document.getElementById('productsInCart').textContent : null;
let productsInCart, productFromPromo;
let isProductPromoRemoved = false;
if(!!productsInCartText) {
  try {
    // Parse the JSON string to an object
    productsInCart = JSON.parse(productsInCartText);
    productFromPromo = findPromoProduct(productsInCart.items , 'original');
    subscribeToEvent();
  } catch (error) {
    console.error('❌ Error parsing JSON', error);
  }
}


/**
 * Subscribes to the 'cart:updated' event and handles cart updates.
 */
async function subscribeToEvent() {
  document.addEventListener('cart:updated', async (event) => {
    if (event.detail?.updateFromPromo) return;

    productsInCart.items = event.detail.cart.items;
    
    if (!productFromPromo) {
      productFromPromo = findPromoProduct(productsInCart.items, 'event');
    }
    
    if (!productFromPromo) return;
    
    if (event.detail.cart.items_removed && event.detail.cart.items_removed.length > 0) {
      isProductPromoRemoved = checkForRemovedProducts(event.detail.cart.items_removed);
    }
    
    if (isProductPromoRemoved) {
      deleteAllCookiesWithName('cart');
      isProductPromoRemoved = false;
      await addProductsAndAttributes(event.detail.cart);
    }
  });
}

/**
 * Finds the promotional product in the given array of products.
 * 
 * @param {Array} products - The array of product objects to search.
 * @param {string} typeOfArray - The type of array being searched ('original' or 'event').
 * @returns {Object|null} The promotional product if found, otherwise null.
 */
function findPromoProduct(products, typeOfArray) {
  if (typeOfArray === 'original') {
    return products.find(product => {
      return product.properties.some(property => property[0] === '_addedByCode');
    });
  } else if (typeOfArray === 'event') {
    return products.find(product => {
      return product.properties && product.properties._addedByCode;
    });
  }
  return null;
}

/**
 * Checks if the promotional product has been removed from the cart.
 * 
 * @param {Array} removedItems - The array of removed product objects.
 * @returns {boolean} True if the promotional product has been removed, otherwise false.
 */
function checkForRemovedProducts(removedItems) {
  return removedItems.some(item => item.variant_id === productFromPromo.variant_id);
}

/**
 * Deletes all cookies with the specified name.
 * 
 * @param {string} name - The name of the cookies to delete.
 */
function deleteAllCookiesWithName(name) {
  const cookies = document.cookie.split(";");

  for (let cookie of cookies) {
      const cookieParts = cookie.split("=");
      const cookieName = cookieParts[0].trim();

      if (cookieName === name) {
          document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      }
  }
}

/**
 * Adds products and attributes to the cart and triggers cart update events.
 * 
 * @param {Object} cart - The cart object containing items and attributes.
 */
async function addProductsAndAttributes(cart) {
  const formData = {
    items: cart.items,
    attributes: cart.attributes
  }

  try {
    const result = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });

    if (result.ok) {
      delete cart.sections;

      document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
        bubbles: true,
        detail: {
          cart: cart,
          updateFromPromo: true
        }
      }));

      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: cart
        }
      }));
    }
  } catch (error) {
    console.error('❌ Error updating cart', error);
  }
}